(function () {
    'use strict';

    angular
        .module('memories')
        .controller('MemoriesModalCtrl', MemoriesModalCtrl);

    MemoriesModalCtrl.$inject = ['$scope', 'outingId', 'memories', 'refresh'
        ,app.modules.common.services.functions
    ];
    function MemoriesModalCtrl($scope, outingId, memories, refresh, ggFunctions) {
        var vm = this;
        vm.outingId = outingId;
        vm.memories = memories;
        vm.add = add;
        vm.refresh = refreshMemories;

        vm.window = ggFunctions.fetchWindowSize();

        function add() {
            $scope.memoryList.addMemory();
        }

        function refreshMemories() {
            refresh().then(function success(res) {
                vm.memories = res;
            });
        }
    }
})();